import React, { ChangeEventHandler, useCallback, useContext } from 'react';
import {
	AttachUiType,
	IChatMediaMessage,
	IFileResource,
	isAttachTypeUiVisible,
	Resource,
} from '@enuan/chat__utils';
import { AttachImg } from './components/AttachImg';
import { AttachPhoto } from './components/AttachPhoto';
import { AttachDoc } from './components/AttachDoc';
// import { AttachLoc } from './components/AttachLoc';
import classNames from 'classnames';
import { styled } from '@mui/material/styles';
import { configurationContext } from '../../../contexts/configuration';

type IAttachListProps = {
	onMedia: (media: IChatMediaMessage<IFileResource>['_data'] | null) => void;
	className?: string;
};

export const AttachList = styled(
	({ onMedia, className }: IAttachListProps) => {
		const { attach_ui } = useContext(configurationContext);

		const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
			async (e) => {
				const { files: _files } = e.currentTarget;
				if (_files) {
					const files: IChatMediaMessage<IFileResource>['_data'][] =
						await Promise.all(
							Array.from({ length: _files.length }).map<
								Promise<IChatMediaMessage<IFileResource>['_data']>
							>(async (_, index) => {
								const file = _files[index];
								const resource = Resource(file);
								return resource;
							}),
						);
					const media: IChatMediaMessage<IFileResource>['_data'] = files[0];

					onMedia(media);
				}
			},
			[onMedia],
		);

		return (
			<div className={classNames('modal__list', className)}>
				{isAttachTypeUiVisible({ attach_ui }, AttachUiType.IMAGE) && (
					<AttachImg onSelect={onChange} />
				)}
				{isAttachTypeUiVisible({ attach_ui }, AttachUiType.PHOTO) && (
					<AttachPhoto onSelect={onChange} />
				)}
				{isAttachTypeUiVisible({ attach_ui }, AttachUiType.DOCUMENT) && (
					<AttachDoc onSelect={onChange} />
				)}
				{/* <AttachLoc
				onSelect={() => {
				}}
			/> */}
			</div>
		);
	},
	{
		label: 'AttachList',
		target: 'AttachList-root',
	},
)({
	padding: 0,
	margin: 0,
	display: 'flex',
	flexDirection: 'column',
});
